// Shared name display helpers. Schedule/grouping/selection UIs show students &
// staff by preferred/first name only (no last names), sorted alphabetically.

export const firstName = (p) => {
  if (!p) return "";
  // staff use a single "name" field; students use preferred_name/first_name
  return (p.preferred_name || p.first_name || (p.name ? p.name.split(" ")[0] : "") || "").trim();
};

export const sortByFirst = (arr) =>
  [...(arr || [])].sort((a, b) => firstName(a).toLowerCase().localeCompare(firstName(b).toLowerCase()));

// Sort records alphabetically by their display `name` field (case-insensitive).
export const sortByName = (arr) =>
  [...(arr || [])].sort((a, b) => String(a?.name || "").toLowerCase().localeCompare(String(b?.name || "").toLowerCase()));

const lastNameOf = (p) => (p?.last_name || (p?.name ? p.name.split(" ").slice(-1)[0] : "") || "");

// Build id -> first-name display map. Adds a last initial only when two people
// share the same first name (e.g. two "Jeremy"s -> "Jeremy S." / "Jeremy T.").
export const buildFirstNameMap = (people) => {
  const counts = {};
  (people || []).forEach((p) => { const f = firstName(p).toLowerCase(); counts[f] = (counts[f] || 0) + 1; });
  const map = {};
  (people || []).forEach((p) => {
    const f = firstName(p);
    const last = lastNameOf(p);
    map[p.id] = counts[f.toLowerCase()] > 1 && last ? `${f} ${last.charAt(0)}.` : f;
  });
  return map;
};
